import Vue from 'vue';
import vueHeadful from 'vue-headful';
import { sync } from 'vuex-router-sync';
import Buefy from 'buefy';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VueVirtualScroller from 'vue-virtual-scroller';
import VueApexCharts from 'vue-apexcharts';
import Datetime from 'vue-datetime';
import DateRangePicker from 'vue2-daterange-picker';
import { ModalPlugin } from 'bootstrap-vue';
import VueTabulator from 'vue-tabulator';
import VueECharts from 'vue-echarts';
import 'boxicons/css/boxicons.css';
import VueSanitize from 'vue-sanitize';
import '@phosphor-icons/web';
// import clientDashboardConfig from './dashboard-config';

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
// import 'vue-datetime/dist/vue-datetime.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import App from './App.vue';
import router from './router';
import store from './store';
import './icon';

Vue.component('vue-headful', vueHeadful);
Vue.component('date-range-picker', DateRangePicker);
Vue.use(Buefy, {
  defaultIconPack: 'fas',
});
Vue.use(VueTextareaAutosize);
Vue.use(VueVirtualScroller);
Vue.use(VueApexCharts);
Vue.use(Datetime);
Vue.use(ModalPlugin);
Vue.use(VueTabulator);
Vue.use(VueSanitize);

Vue.component('apexchart', VueApexCharts);
Vue.component('v-chart', VueECharts);
Vue.filter('capitalize', (value) => {
  if (!value) return '';
  const strValue = value.toString();
  return strValue.charAt(0).toUpperCase() + strValue.slice(1);
});

Vue.filter('number', (value) => {
  if (!value) return 0;
  return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

Vue.filter('si_number', (number) => {
  const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
  let tier = Math.trunc(Math.log10(number) / 3);
  // if zero, we don't need a suffix
  if (tier <= 0) return number;
  if (tier > 6) tier = 6;
  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier];
  const scale = 10 ** (tier * 3);
  // scale the number
  const scaled = number / scale;
  // format number and add suffix
  return scaled.toFixed(1) + suffix;
});

Vue.config.productionTip = false;

Vue.prototype.$eventHub = new Vue();

sync(store, router);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// const loadServerConfig = async () => {
//   await clientDashboardConfig.loadServerConfig();
// };
//
// loadServerConfig().then(() => {
//   Vue.component('vue-headful', vueHeadful);
//   Vue.component('date-range-picker', DateRangePicker);
//   Vue.use(Buefy, {
//     defaultIconPack: 'fas',
//   });
//   Vue.use(VueTextareaAutosize);
//   Vue.use(VueVirtualScroller);
//   Vue.use(VueApexCharts);
//   Vue.use(Datetime);
//   Vue.use(ModalPlugin);
//   Vue.use(VueTabulator);
//
//   Vue.component('apexchart', VueApexCharts);
//   Vue.component('v-chart', VueECharts);
//   Vue.filter('capitalize', (value) => {
//     if (!value) return '';
//     const strValue = value.toString();
//     return strValue.charAt(0).toUpperCase() + strValue.slice(1);
//   });
//
//   Vue.filter('number', (value) => {
//     if (!value) return 0;
//     return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
//   });
//
//   Vue.filter('si_number', (number) => {
//     const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
//     let tier = Math.trunc(Math.log10(number) / 3);
//     // if zero, we don't need a suffix
//     if (tier <= 0) return number;
//     if (tier > 6) tier = 6;
//     // get suffix and determine scale
//     const suffix = SI_SYMBOL[tier];
//     const scale = 10 ** (tier * 3);
//     // scale the number
//     const scaled = number / scale;
//     // format number and add suffix
//     return scaled.toFixed(1) + suffix;
//   });
//
//   Vue.config.productionTip = false;
//
//   Vue.prototype.$eventHub = new Vue();
//
//   sync(store, router);
//
//   new Vue({
//     router,
//     store,
//     render: (h) => h(App),
//   }).$mount('#app');
// });
